import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "layout-unit-L-box" }
const _hoisted_2 = { class: "layout-unit-S-box" }
const _hoisted_3 = ["onClick"]

import { ref, onMounted, reactive, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import popup from "@/components/hof-popup/index.vue";
import usePopupHof from "@/composables/usePopupHof";
import jsonp from "@/libs/api.request.js";

interface List {
  data: any[];
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const list: List = reactive({ data: [] });

function showCard(index: number) {
  list.data.map((i) => {
    i.show = false;
  });
  list.data[index].show = true;
}

function closeCard() {
  list.data.map((i) => {
    i.show = false;
  });
}

function format(data: Array<Array<string>>) {
  return data.slice(1, data.length).map((i: string[]) => {
    return {
      name: i[6],
      TitleClass: i[7],
      detail: i[8].split(";")[0],
      avatar1: i[8].split(";")[1],
      avatar2: i[8].split(";")[2],
      area: i[9],
      keyword: i[10],
      nameTag: i[8].split(";")[3],
      show: false,
    };
  });
}

function fetchContent() {
  jsonp("https://news-my.web.sdo.com/UniInterface/news/newslist.asp", {
    CategoryCode: 7881,
    pageSize: 10,
    pageIndex: 0,
    Keyword: "",
    Type: "json",
  }).then((res: any) => {
    if (res.Code == 0 && res.TotalCount > 0) {
      list.data = format(res.dataList);
    } else {
      list.data = [];
    }

    console.log(list.data);
  });
}

onMounted(() => {
  fetchContent();
});

onUnmounted(() => {
  // fetchContent();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "page-hof",
    onClick: closeCard
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list).data, (item, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "unit-L hof-unit",
          key: index
        }, [
          _createElementVNode("div", {
            class: "avatar",
            style: _normalizeStyle({ backgroundImage: `url(${item.avatar1})` })
          }, null, 4),
          _createVNode(popup, {
            isShow: true,
            data: item
          }, null, 8, ["data"])
        ])), [
          [_vShow, index < 4]
        ])
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list).data, (item, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "unit-S",
          key: index,
          onClick: _withModifiers(($event: any) => (showCard(index)), ["stop"])
        }, [
          _createElementVNode("div", {
            class: "unit-s-img",
            style: _normalizeStyle({ backgroundImage: `url(${item.avatar1})` })
          }, null, 4),
          _createElementVNode("div", {
            class: "name-tag",
            style: _normalizeStyle({ backgroundImage: `url(${item.nameTag})` })
          }, null, 4),
          _createVNode(popup, {
            isShow: item.show,
            data: item
          }, null, 8, ["isShow", "data"])
        ], 8, _hoisted_3)), [
          [_vShow, index >= 4]
        ])
      }), 128))
    ])
  ]))
}
}

})